import React from 'react';
import { OddPlateView } from '~atoms';
import { OddWidth } from '~constants/view/OddWidth';
var OddPlate = function (_a) {
    var _b = _a.value, value = _b === void 0 ? 0 : _b, isSelected = _a.isSelected, _c = _a.oddWidth, oddWidth = _c === void 0 ? OddWidth.S : _c, onClick = _a.onClick;
    var isActive = !!value;
    return (React.createElement(OddPlateView, { value: value, title: "", active: isActive, oddWidth: oddWidth, onClick: isActive ? onClick : undefined, selected: isSelected }));
};
export { OddPlate };
